'use client';

import {PAPER_BACKGROUND} from "@/src/constant/constant";
import {Box} from "@mui/material";
import {ReactNode} from "react";

const GradientBox = ({children}: { children: ReactNode }) => {
    return (
        <Box
            flex={1}
            sx={{
                background: (theme) =>
                    `linear-gradient(to bottom, ${theme.palette.custom?.backgroundGradient}, transparent 232px),
                     url(${PAPER_BACKGROUND}), ${theme.palette.background.default}`,
            }}>
            {children}
        </Box>
    )
}

export default GradientBox;
